'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getKey = function getKey(level, column, index) {
  return [level, column, index].join('-');
};

exports.default = getKey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/utils/getKey.js
// module id = 442
// module chunks = 0